import React, {useCallback, useRef, useState, useEffect} from "react";
import {useIntl} from "react-intl";
import {Check, Palette} from "lucide-react";
import {getContrastColors} from "../../UIElements";
import {renderIcon, CURATED_ICONS, CURATED_COLORS} from "../../utils/botIconUtils";
import "./BotAppearance.scss";

const BotAppearance = ({name, icon, color, updateBotData}) => {
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);
    const currentColor = color || '#9EA5F8';
    const {textColor, iconBackground} = getContrastColors(currentColor);

    const handleToggle = useCallback(() => {
        setIsOpen(prev => !prev);
    }, []);

    useEffect(() => {
        if (!isOpen) return;
        const handleClick = (e) => {
            if (!containerRef.current?.contains(e.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, [isOpen]);

    return (
        <div className="bot-appearance" ref={containerRef}>
            <label onClick={handleToggle}>
                <Palette size={16} />
                {intl.formatMessage({
                    id: 'botAppearance',
                    defaultMessage: 'Appearance',
                })}
            </label>
            <div
                className="bot-appearance__preview-badge"
                onClick={handleToggle}
                style={{backgroundColor: currentColor, color: textColor}}
            >
                <div className="bot-appearance__preview-badge-icon" style={{backgroundColor: iconBackground}}>
                    {renderIcon(icon, 20)}
                </div>
                <span className="bot-appearance__preview-badge-name">
                        {name || intl.formatMessage({id: 'botName.placeholder', defaultMessage: 'Bot name'})}
                    </span>
            </div>
            {isOpen && (
                <div className="bot-appearance__picker">
                    <div className="bot-appearance__colors">
                        {CURATED_COLORS.map(hex => (
                            <button
                                key={hex}
                                className={`bot-appearance__colors-swatch ${color === hex ? 'selected' : ''}`}
                                style={{backgroundColor: hex}}
                                onClick={() => updateBotData("color", hex)}
                                type="button"
                            >
                                {color === hex && <Check size={14} color={getContrastColors(hex).textColor}/>}
                            </button>
                        ))}
                    </div>
                    <div className="bot-appearance__icons">
                        {CURATED_ICONS.map(iconName => (
                            <button
                                key={iconName}
                                className={`bot-appearance__icons-button ${icon === iconName ? 'selected' : ''}`}
                                style={icon === iconName ? {backgroundColor: currentColor, borderColor: currentColor, color: textColor} : undefined}
                                onClick={() => updateBotData("icon", iconName)}
                                type="button"
                            >
                                {renderIcon(iconName, 20)}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default BotAppearance;
